<template>
  <v-card>
    <v-form @submit.prevent="submitEditRate()" ref="editRateForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 class="flex-container-space-between">
            <span class="headline">
              Edit rate
              <span class="grey--text subheading">- {{rate.project.name || rate.id}}</span>
            </span>
            <div>
              <v-switch
                :color="primaryNeutral"
                class="mt-0"
                label="Active rate"
                v-model="editedRate.active"
              ></v-switch>
            </div>
          </v-flex>
          <v-flex class="text-xs-right py-0 my-0">
            <v-btn
              flat
              color="grey"
              router
              :to="{name: 'rateDetail', params: {id: rate.id}}"
              style="text-transform: capitalize"
            >See Details & History...</v-btn>
          </v-flex>
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">
              Master Files
              <span class="caption font-italic">(At least one required) *</span>
            </div>
          </v-flex>

          <v-flex xs12 sm6 v-for="(item, i) in autoCompletes" :key="i">
            <v-autocomplete
              :label="item.label"
              :items="$store.state[item.items][item.items]"
              :prepend-icon="$store.state.global.pages[item.page].icon"
              :item-text="item.itemText"
              item-value="id"
              v-model="editedRate[item.value]"
              no-data-text="No data found"
              :color="primaryNeutral"
              clearable
              :clear-icon-cb="() => $nextTick(() => editedRate[item.value] = null)"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12>
            <v-expansion-panel expand class="grey lighten-3">
              <v-expansion-panel-content class="grey lighten-4">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon
                    :color="$store.state.global.pages.vehicleType.color"
                    class="mr-2"
                  >{{$store.state.global.pages.vehicleType.icon}}</v-icon>Selected Vehicles
                </div>

                <v-list subheader>
                  <v-list-tile
                    v-for="item in $store.state.vehicleTypes.vehicleTypes"
                    :key="item.id"
                    fluid
                  >
                    <v-checkbox
                      v-model="selectedVehicleTypeIds"
                      :label="item.name_tonnage"
                      :value="item.id"
                    ></v-checkbox>
                  </v-list-tile>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>

          <!-- STANDARD COST -->
          <!-- STANDARD COST -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Cost</div>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <v-text-field
              label="* Cost price"
              v-model="editedRate.costPrice"
              prepend-icon="attach_money"
              :rules="priceRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <span class="pt-4 pr-3">/</span>
            <v-autocomplete
              label="Cost unit"
              :items="units"
              v-model="editedRate.costUnit"
              no-data-text="An error occured"
              :color="primaryNeutral"
            ></v-autocomplete>
          </v-flex>

          <!-- STANDARD SELL -->
          <!-- STANDARD SELL -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Sell</div>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <v-text-field
              label="* Sell price"
              v-model="editedRate.sellPrice"
              prepend-icon="attach_money"
              :rules="priceRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <span class="pt-4 pr-3">/</span>
            <v-autocomplete
              label="Sell unit"
              :items="units"
              v-model="editedRate.sellUnit"
              no-data-text="An error occured"
              :color="primaryNeutral"
            ></v-autocomplete>
          </v-flex>

          <!-- RATE OPTIONS -->
          <!-- RATE OPTIONS -->
          <v-flex xs12 sm4 class="flex-container-space-between">
            <v-text-field
              type="number"
              label="Alt. Rate Trips"
              hint="This setting affects docket imports only"
              :color="primaryNeutral"
              v-model="editedRate.altRateTrips"
              :rules="altRateTripsRules"
              prepend-icon="calendar_today"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-switch
              :color="primaryNeutral"
              label="Admin fee required"
              v-model="editedRate.adminFeeRequired"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm4 class="vertical-center-container">
            <v-switch
              :color="primaryNeutral"
              class="mt-0"
              label="Use Vehicle Type tonnage"
              v-model="editedRate.useTonnage"
            ></v-switch>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              label="Notes"
              prepend-icon="note"
              :rules="notesRules"
              v-model="editedRate.notes"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <!-- ALTERNATE COST -->
            <!-- ALTERNATE COST -->
            <v-expansion-panel expand class="grey lighten-5 mb-3">
              <v-expansion-panel-content class="grey lighten-5">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon color="orange" class="mr-2">access_time</v-icon>Alternate Rate
                </div>
                <form-container class="pl-2 pr-2">
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Cost price"
                      :color="primaryNeutral"
                      v-model="editedRate.costPriceAlt"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Cost unit Alt"
                      :items="units"
                      v-model="editedRate.costUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Sunday Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Sunday Cost price"
                      :color="primaryNeutral"
                      v-model="editedRate.costPriceAltSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Cost unit Alt"
                      disabled
                      :items="units"
                      v-model="editedRate.costUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Sell price"
                      :color="primaryNeutral"
                      v-model="editedRate.sellPriceAlt"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Sell unit Alt"
                      :items="units"
                      v-model="editedRate.sellUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Sunday Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Sunday Sell price"
                      :color="primaryNeutral"
                      v-model="editedRate.sellPriceAltSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Sell unit Alt"
                      disabled
                      :items="units"
                      v-model="editedRate.sellUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                </form-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-spacer></v-spacer>

            <v-expansion-panel expand class="grey lighten-5 mb-3">
              <v-expansion-panel-content class="grey lighten-5">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon color="blue darken-4" class="mr-2">alarm_off</v-icon>Night Rate
                </div>
                <form-container class="pl-2 pr-2">
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Cost price"
                      :color="primaryNeutral"
                      v-model="editedRate.costPriceNight"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Cost unit"
                      :items="units"
                      v-model="editedRate.costUnitNight"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Sell price"
                      :color="primaryNeutral"
                      v-model="editedRate.sellPriceNight"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Sell unit"
                      :items="units"
                      v-model="editedRate.sellUnitNight"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                </form-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel expand class="grey lighten-5 mb-1">
              <v-expansion-panel-content class="grey lighten-5">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon color="blue" class="mr-2">weekend</v-icon>Sunday Rate
                </div>
                <form-container class="pl-2 pr-2">
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Cost price"
                      :color="primaryNeutral"
                      v-model="editedRate.costPriceSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Cost unit"
                      :items="units"
                      v-model="editedRate.costUnitSunday"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Sell price"
                      :color="primaryNeutral"
                      v-model="editedRate.sellPriceSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Sell unit"
                      :items="units"
                      v-model="editedRate.sellUnitSunday"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                </form-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RateService from "@/services/requests/rateService";
import SiteService from "@/services/requests/siteService";
import TipService from "@/services/requests/tipService";
import SpoilService from "@/services/requests/spoilService";
import VehicleService from "@/services/requests/vehicleService";
import RateValidation from "@/services/validation/rateValidation";

import FilterTipSpoils from "@/services/mixins/filterTipSpoils";

//import getProjects from '@/services/mixins/getMasterFiles/getProjects'
import getSites from "@/services/mixins/getMasterFiles/getSites";
import getTips from "@/services/mixins/getMasterFiles/getTips";
import getSpoils from "@/services/mixins/getMasterFiles/getSpoils";
import getVehicleTypes from "@/services/mixins/getMasterFiles/getVehicleTypes";

export default {
  mixins: [
    RateValidation,
    FilterTipSpoils,
    //getProjects,
    getSites,
    getTips,
    getSpoils,
    getVehicleTypes
  ],
  data() {
    return {
      keepMasterFiles: true,
      color: "blue",
      units: ["TONNE", "HOUR", "DAY", "EA"],
      loading: false,
      editedRate: Object.assign({}, this.rate),
      prefix: "editedRate",
      selectedVehicleTypeIds: [],
      currentVehicleTypeIds: [],
      autoCompletes: [
        {
          label: "* Project",
          value: "projectId",
          items: "projects",
          page: "project",
          itemText: "name"
        },
        {
          label: "Site",
          value: "siteId",
          items: "sites",
          page: "site",
          itemText: "siteName_projectName"
        },
        {
          label: "Spoil",
          value: "spoilId",
          items: "spoils",
          page: "spoil",
          itemText: "name"
        },
        {
          label: "Tip",
          value: "tipId",
          items: "tips",
          page: "tip",
          itemText: "name"
        }
      ]
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedRate = Object.assign({}, this.rate);
      this.selectedVehicleTypeIds = this.currentVehicleTypeIds;

      this.close();
    },
    submitEditRate() {
      if (!this.$refs.editRateForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.editedRate.vehicleTypeIds = this.selectedVehicleTypeIds;
      this.save();
    },
    save() {
      this.loading = true;
      RateService.updateRate(this.editedRate)
        .then(result => {
          this.loading = false;
          result.data.result.rate.updated = true;
          this.$store.commit("rates/updateArrayStateByValue", {
            prop: "rates",
            value: this.rate,
            editedValue: result.data.result.rate
          });
          //this.$store.commit("rates/modifyRate", {rate: this.rate, editedRate: result.data.result.rate})
          this.editedRate = Object.assign({}, result.data.result.rate);
          this.currentVehicleTypeIds = this.selectedVehicleTypeIds;

          this.snack({ text: "Rate was edited!", color: "green" });
          //console.log("testing");
          //console.log(result.data.result);
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    },
    filterByProject(list, projectId) {
      return list.filter(record => {
        return record.projectId == projectId;
      });
    },
    // getRateVehicleIds() {
    //     var data = this.editedRate.rateVehicleTypes.length > 0
    //         ? this.editedRate.rateVehicleTypes.map(item =>item.vehicleTypeId)
    //         : []
    //     this.setRateVehicleIds(data)
    // },
    setRateVehicleIds() {
      // var data = this.editedRate.rateVehicleTypes.length > 0
      //     ? this.editedRate.rateVehicleTypes.map(item =>item.vehicleTypeId)
      //     : []
      this.selectedVehicleTypeIds = [];
      this.currentVehicleTypeIds = [];
      for (var record of this.editedRate.rateVehicleTypes) {
        this.selectedVehicleTypeIds.push(record.vehicleTypeId);
        this.currentVehicleTypeIds.push(record.vehicleTypeId);
      }
    }
  },
  props: {
    rate: Object
  },
  computed: {
    filteredSites() {
      if (!!this.rate.projectId) {
        return this.filterByProject(this.sites, this.rate.projectId);
      } else {
        return this.sites;
      }
    },
    different() {
      if (
        !this._.isEqual(this.rate, this.editedRate) ||
        !this._.isEqual(
          this.selectedVehicleTypeIds.sort().join(","),
          this.currentVehicleTypeIds.sort().join(",")
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    rate(val) {
      this.editedRate = Object.assign({}, val);
    }
  },
  mounted() {
    this.setRateVehicleIds();
  }
};
</script>

<style>
</style>
